import { AccessProps } from "types";

export type DeveloperSidebarAccessProps = Omit<
  AccessProps,
  "hasAccessToOrganizationUserApi"
>;

export const canAccessAnalytics = (accessor: DeveloperSidebarAccessProps) =>
  accessor.hasPermission("VIEW_EMBED_DASHBOARD") &&
  accessor.user.organization.analyticsDashboards.length > 0;
